import {create} from 'zustand';

export const useConsole = create((set) => ({
    consoleHeight: '421px',
    isResizing: false,
    isConsoleOpen: false,
    newTerminalWithCredentials: null,
    setConsoleHeight: (height) => set(() => ({consoleHeight: height})),
    setIsResizing: (resizing) => set(() => ({isResizing: resizing})),
    setIsConsoleOpen: (consoleOpen) => set(() => ({isConsoleOpen: consoleOpen})),
    addTerminalWithCredentials : (credt) => set(() => ({newTerminalWithCredentials: credt})),
    setIsMaximized: (isMaximized) => set(() => ({isMaximized})),
}));